import { BaseListViewStore, ProductHyperLinkCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { TableFilterUtility } from 'core/utils';
import { LookupStore } from 'modules/lookup/stores';

class FulfillmentOrderItemsListViewStore extends BaseListViewStore {
	@observable change = false;
	showActions = false;
	noDataItem = true;

	constructor(rootStore) {
		super(rootStore, {
			listStore: new FulfillmentOrderStore(rootStore),
			queryParams: {
				embed: [],
				filter: null,
				ignore: true,
			},
			findFunction: 'findFulfillmentOrderItems',
			tableData: {
				columns: [
					{
						key: 'product.name',
						title: 'FULFILLMENTORDERITEMSVIEW.NAME',
						selected: true,
						width: 200,
						filter: null,
						sortable: false,
						resizable: false,
					},
					{
						key: 'sku',
						title: 'FULFILLMENTORDERITEMSVIEW.SKU',
						dataCell: ProductHyperLinkCellData,
						onClick: item => this.routes.detail(item.productId),
						selected: true,
						width: 200,
						filter: null,
						sortable: false,
						resizable: false,
					},
					{
						key: 'quantity',
						title: 'FULFILLMENTORDERITEMSVIEW.QUANTITY',
						selected: true,
						width: 200,
						filter: null,
						sortable: false,
						resizable: false,
					},
				],
				sortObject: [],
				actions: {},
			},
			permissions: {
				read: () => this.authStore.hasPermission('productSection.read'),
			},
			routes: {
				detail: id =>
					this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
						id,
					}),
			},
		});
		makeObservable(this);
		this.tableFilter = new TableFilterUtility({
			lookupStore: new LookupStore(rootStore),
			listStore: this.listStore,
			queryUtility: this.queryUtility,
			columns: this.tableData.columns,
			service: this.listStore.service,
		});
	}

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound async findFulfillmentOrderItems() {}
}

export default FulfillmentOrderItemsListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderItemsListViewStore.js